import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';
export const SEEK_TRUTH_VIDEO_TYPES = [
]

const entityColumns = {
  id: {
    model_name: 'SeekTruthVideo',
    column_type: 'id',
  },
  created_at: {
    model_name: 'SeekTruthVideo',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'SeekTruthVideo',
    column_type: 'datetime',
  },
  title: {
    model_name: 'SeekTruthVideo',
    column_type: 'string',
  },
  type: {
    model_name: 'SeekTruthVideo',
    column_type: 'type',
    extra: {
      options: [],
    },
  },
  likes_count: {
    model_name: 'SeekTruthVideo',
    column_type: 'integer',
  },
  views_count: {
    model_name: 'SeekTruthVideo',
    column_type: 'integer',
  },
  stars_count: {
    model_name: 'SeekTruthVideo',
    column_type: 'integer',
  },
  shares_count: {
    model_name: 'SeekTruthVideo',
    column_type: 'integer',
  },
  comments_count: {
    model_name: 'SeekTruthVideo',
    column_type: 'integer',
  },
  published_at: {
    model_name: 'SeekTruthVideo',
    column_type: 'datetime',
  },
  author: {
    model_name: 'SeekTruthVideo',
    column_type: 'string',
  },
  source: {
    model_name: 'SeekTruthVideo',
    column_type: 'string',
  },
  share_desc: {
    model_name: 'SeekTruthVideo',
    column_type: 'string',
  },
  is_top: {
    model_name: 'SeekTruthVideo',
    column_type: 'boolean',
  },
  content_type: {
    model_name: 'SeekTruthVideo',
    column_type: 'enum',
  },
  note: {
    model_name: 'SeekTruthVideo',
    column_type: 'string',
  },
  subtitle: {
    model_name: 'SeekTruthVideo',
    column_type: 'string',
  },
  cover: {
    model_name: 'SeekTruthVideo',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  commentable_comment_datum: {
    model_name: 'SeekTruthVideo',
    column_type: 'has_one',
    extra: {
      polymorphic: '',
      association_name: 'commentable_comment_datum',
      model_name: 'CommentableCommentDatum',
      foreign_key: 'target_id',
    },
  },
  target_id: {
    model_name: 'SeekTruthVideo',
    column_type: 'has_one',
    extra: {
      polymorphic: '',
      association_name: 'commentable_comment_datum',
      model_name: 'CommentableCommentDatum',
      foreign_key: 'target_id',
    },
  },
  video: {
    model_name: 'SeekTruthVideo',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
}

export const columnsExtend = (columns, { filterColumnsExtend } = {}) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
